import { InjectionToken } from '@angular/core';

export interface TranslationWrapperService {
  translate: (key: string | Array<string>, interpolateParams?: Object) => any;
}

export const TRANSLATION_SERVICE_TOKEN = new InjectionToken<TranslationWrapperService>('TRANSLATION_SERVICE_TOKEN');
